import { ErrorType } from '../types/enums'
import { ErrorContentType } from '../types/errorTypes'

export const UNKNOWN_ERROR_HEADER = 'Unknown error'

export const UNKNOWN_ERROR_CONTENT: ErrorContentType = {
  errorHeader: UNKNOWN_ERROR_HEADER,
  errorText: '',
  errorType: ErrorType.UNKNOWN
}

export const TRANSLATIONS_ERROR = 'Error loading translations'
